module.exports = __webpack_public_path__ + "img/medialuna-dulce.1e28b192.jpeg";